module.exports = __webpack_public_path__ + "img/VL_11_01.9a40b165.png";